import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';
import { type QuoteStatusFilter, statusesForFilter } from '../model/status-filter';

const QUOTES_PAGE_SIZE = 20;

interface QuotesListParams {
  readonly page: number;
  readonly statusFilter: QuoteStatusFilter;
  /** 견적 번호·회사명·담당자명 검색. 빈 문자열은 입력에서 뺀다. */
  readonly search: string;
}

/**
 * 어드민 견적 목록(quoteManagement.list, 견적 설계 §6-1) — 기본 필터는 입력에서 빼서 서버 기본값(처리할 건)을 쓴다.
 * 쪽을 옮기는 동안 이전 쪽 표를 유지한다.
 */
export const useQuotesListQuery = ({ page, statusFilter, search }: QuotesListParams) => {
  const statuses = statusesForFilter(statusFilter);
  const trimmedSearch = search.trim();

  return trpc.quoteManagement.list.useQuery(
    {
      page,
      limit: QUOTES_PAGE_SIZE,
      ...(statuses ? { statuses } : {}),
      ...(trimmedSearch ? { search: trimmedSearch } : {}),
    },
    { placeholderData: keepPreviousData },
  );
};
